export default "__VITE_ASSET__BKX9ufQo__"